import React from 'react';
import { useStatistics } from './StatiscticsContext';
import SalesIcon from '@/assets/icons/V3/statistics/SalesIcon.svg?react';
import AdjustmentIcon from '@/assets/icons/V3/statistics/AdjustmentIcon.svg?react';

const autoComma = (num?: number) => (typeof num === 'number' ? num.toLocaleString('ko-KR') : '-');

const StatisticsSummary = () => {
  const { salesInfo, settleInfo } = useStatistics();

  return (
    <div className="scrollbar flex-1 overflow-x-auto rounded-[16px] bg-white">
      <div
        className="
          flex flex-wrap items-center
          gap-x-4 gap-y-4 p-4 md:gap-x-[30px]
          lg:gap-x-[60px]
        "
      >
        {/* 매출 블록 */}
        <div className="flex min-w-[260px] items-center gap-5">
          <div className="flex items-center gap-3">
            <div className="flex items-center gap-1 text-gr-800 Body2M16">
              <SalesIcon />
              <span>매출</span>
            </div>
            <div className="flex text-gr-800 Body1S16">
              <span>{autoComma(salesInfo.TotalSalesAmount)}원</span>
              <span>({autoComma(salesInfo.TotalSalesCount)}건)</span>
            </div>
          </div>
          <div className="flex items-center gap-3 text-gr-700 Body5M14">
            <div>배송비 </div>
            <span>{autoComma(salesInfo.TotalSalesShippingFee)}원</span>
          </div>
          <div className="flex items-center gap-3 text-gr-700 Body5M14">
            <span>할인금액</span>
            <span>{autoComma(salesInfo.TotalSalesDiscountAmount)}원</span>
          </div>
        </div>
        {/* 정산 블록 */}
        <div className="flex min-w-[260px] items-center gap-5">
          <div className="flex items-center gap-3">
            <div className="flex items-center gap-1 text-gr-800 Body2M16">
              <AdjustmentIcon />
              <span>정산</span>
            </div>
            <div className="flex text-gr-800 Body1S16">
              <span>{autoComma(settleInfo.TotalSettleAmount)}원</span>
            </div>
            <div className="flex items-center gap-3 text-gr-700 Body5M14">
              <div>완료 </div>
              <span> {autoComma(settleInfo.TotalSettleCompletionAmount)}원</span>
            </div>
            <div className="flex items-center gap-3 text-gr-700 Body5M14">
              <span>예정</span>
              <span>{autoComma(settleInfo.TotalSettleYetAmount)}원</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatisticsSummary;
